import { render, staticRenderFns } from "./FamilyDataInfoChildTable.vue?vue&type=template&id=288ef8d1&scoped=true&"
import script from "./FamilyDataInfoChildTable.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataInfoChildTable.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataInfoChildTable.vue?vue&type=style&index=0&id=288ef8d1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ef8d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VContainer,VLayout,VRow,VSpacer,VTooltip})
